import img0 from '@/views/act/monopoly/assets/img/game-board-bottom/0.png'
import img1 from '@/views/act/monopoly/assets/img/game-board-bottom/1.png'
import img2 from '@/views/act/monopoly/assets/img/game-board-bottom/2.png'
import img3 from '@/views/act/monopoly/assets/img/game-board-bottom/3.png'
import img4 from '@/views/act/monopoly/assets/img/game-board-bottom/4.png'
import img5 from '@/views/act/monopoly/assets/img/game-board-bottom/5.png'
import img6 from '@/views/act/monopoly/assets/img/game-board-bottom/6.png'
import img7 from '@/views/act/monopoly/assets/img/game-board-bottom/7.png'
import img8 from '@/views/act/monopoly/assets/img/game-board-bottom/8.png'
import img9 from '@/views/act/monopoly/assets/img/game-board-bottom/9.png'
import img10 from '@/views/act/monopoly/assets/img/game-board-bottom/10.png'
import img11 from '@/views/act/monopoly/assets/img/game-board-bottom/11.png'
import img12 from '@/views/act/monopoly/assets/img/game-board-bottom/12.png'
import img13 from '@/views/act/monopoly/assets/img/game-board-bottom/13.png'
import img14 from '@/views/act/monopoly/assets/img/game-board-bottom/14.png'
import img15 from '@/views/act/monopoly/assets/img/game-board-bottom/15.png'
import img16 from '@/views/act/monopoly/assets/img/game-board-bottom/16.png'
import img17 from '@/views/act/monopoly/assets/img/game-board-bottom/17.png'
import img18 from '@/views/act/monopoly/assets/img/game-board-bottom/18.png'
import img19 from '@/views/act/monopoly/assets/img/game-board-bottom/19.png'
import img20 from '@/views/act/monopoly/assets/img/game-board-bottom/20.png'
import img21 from '@/views/act/monopoly/assets/img/game-board-bottom/21.png'
import img22 from '@/views/act/monopoly/assets/img/game-board-bottom/22.png'
import img23 from '@/views/act/monopoly/assets/img/game-board-bottom/23.png'
import boxNormal from '@/views/act/monopoly/assets/img/game-board-box/normal.png'
import boxLucky from '@/views/act/monopoly/assets/img/game-board-box/luck.png'
import boxMystery from '@/views/act/monopoly/assets/img/game-board-box/mystery.png'

const baseY = 678

// boxType: normal / lucky / mystery；起点、前进、后退格无宝箱
// cell 10 虽为 forward，前端按城堡直达展示
const cellMeta = [
  { cellIndex: 0, kind: 'start' },
  { cellIndex: 1, kind: 'normal', box: boxNormal },
  { cellIndex: 2, kind: 'lucky', box: boxLucky },
  { cellIndex: 3, kind: 'normal', box: boxNormal },
  { cellIndex: 4, kind: 'back', moveSteps: 1 },
  { cellIndex: 5, kind: 'normal', box: boxNormal },
  { cellIndex: 6, kind: 'forward', moveSteps: 5 },
  { cellIndex: 7, kind: 'normal', box: boxNormal },
  { cellIndex: 8, kind: 'lucky', box: boxLucky },
  { cellIndex: 9, kind: 'normal', box: boxNormal },
  { cellIndex: 10, kind: 'castle', moveSteps: 12 },
  { cellIndex: 11, kind: 'normal', box: boxNormal },
  { cellIndex: 12, kind: 'forward', moveSteps: 3 },
  { cellIndex: 13, kind: 'normal', box: boxNormal },
  { cellIndex: 14, kind: 'lucky', box: boxLucky },
  { cellIndex: 15, kind: 'normal', box: boxNormal },
  { cellIndex: 16, kind: 'normal', box: boxNormal },
  { cellIndex: 17, kind: 'lucky', box: boxLucky },
  { cellIndex: 18, kind: 'normal', box: boxNormal },
  { cellIndex: 19, kind: 'lucky', box: boxLucky },
  { cellIndex: 20, kind: 'forward', moveSteps: 2 },
  { cellIndex: 21, kind: 'mystery', box: boxMystery },
  { cellIndex: 22, kind: 'normal', box: boxNormal },
  { cellIndex: 23, kind: 'back', moveSteps: 1 },
]

const bottomImgs = [
  img0, img1, img2, img3, img4, img5, img6, img7, img8, img9,
  img10, img11, img12, img13, img14, img15, img16, img17, img18, img19,
  img20, img21, img22, img23,
]

const positions = [
  { x: 306, y: 678 - baseY, zIndex: 0 },
  { x: 232, y: 731 - baseY, zIndex: 1 },
  { x: 159, y: 784 - baseY, zIndex: 2 },
  { x: 85, y: 837 - baseY, zIndex: 3 },
  { x: 9, y: 897 - baseY, zIndex: 4 },
  { x: 85, y: 951 - baseY, zIndex: 5 },
  { x: 9, y: 1005 - baseY, zIndex: 6 },
  { x: 85, y: 1059 - baseY, zIndex: 7 },
  { x: 7, y: 1113 - baseY, zIndex: 8 },
  { x: 82, y: 1169 - baseY, zIndex: 9 },
  { x: 157, y: 1224 - baseY, zIndex: 10 },
  { x: 231, y: 1280 - baseY, zIndex: 11 },
  { x: 306, y: 1335 - baseY, zIndex: 12 },
  { x: 380, y: 1280 - baseY, zIndex: 11 },
  { x: 454, y: 1224 - baseY, zIndex: 10 },
  { x: 528, y: 1169 - baseY, zIndex: 9 },
  { x: 602, y: 1113 - baseY, zIndex: 8 },
  { x: 528, y: 1059 - baseY, zIndex: 7 },
  { x: 602, y: 1005 - baseY, zIndex: 6 },
  { x: 528, y: 950 - baseY, zIndex: 5 },
  { x: 602, y: 897 - baseY, zIndex: 4 },
  { x: 528, y: 842 - baseY, zIndex: 3 },
  { x: 454, y: 788 - baseY, zIndex: 2 },
  { x: 380, y: 733 - baseY, zIndex: 1 },
]

export const localeBoardCells = cellMeta.map((meta, index) => ({
  cellIndex: meta.cellIndex,
  kind: meta.kind,
  moveSteps: meta.moveSteps || 0,
  boxImg: meta.box || '',
  position: { x: positions[index].x, y: positions[index].y },
  img: bottomImgs[index],
  zIndex: positions[index].zIndex,
}))
